import { commentsItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/15 text-secondary-300 border border-secondary-500/20 mb-4">
            用户声音
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50">
            用户热评
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            看看其他用户对黑料官网的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {commentsItems.slice(0, 3).map((comment) => (
            <div
              key={comment.id}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/50"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-200 truncate">{comment.name}</p>
                  <p className="text-xs text-foreground-600">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4">
          {commentsItems.slice(3).map((comment) => (
            <div
              key={comment.id}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/50"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-200 truncate">{comment.name}</p>
                  <p className="text-xs text-foreground-600">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}